export const optionsColumnChart = {
    height: 300,
    width: "100%",
    animation: {
        'startup': true,
        duration: 1000,
        easing: 'out',
    },
    colors: [
        '#fecc00',
    ],
    legend: {
        position: 'none'
    },
    backgroundColor: {
        fill: '#fff',
        fillOpacity: 1
    },
    chartArea: {
        top: 10,
        left: 30,
        height: '80%',
        width: '100%'
    },
    hAxis: {
        format: 'MM dd'
    },
    crosshair: {
        trigger: 'both',
        color: '#fecc00',
        opacity: '0.5'
    },
    tooltip: {
        isHtml: true
    }
};
